import { Fragment, memo } from 'react';

import { InfoRow, InfoRowSection } from 'containers/components/EntityDetailV2';

import ActivityDetailContainer from '../ActivityDetailContainer';

const IntegrationDetail = memo(({ activity, labels, shared }) => {
    const { finalContactContent, rightContent, titleRow } = shared;

    return (
        <ActivityDetailContainer
            activity={activity}
            content={{
                right: (
                    <Fragment>
                        {titleRow}
                        <InfoRowSection>
                            <InfoRow
                                label={labels.contact}
                                value={finalContactContent}
                                rightContent={rightContent}
                            />
                        </InfoRowSection>
                    </Fragment>
                ),
            }}
        />
    );
});

IntegrationDetail.displayName = 'IntegrationDetail';

export default IntegrationDetail;
